import { Checkbox as YaComCheckbox, CheckboxProps } from '@yanolja-rnd/ya-com-checkbox'
import styled from '~/app/components/styled'

// YaCom Checkbox 에 공통 스타일 적용
const CheckboxStyle = styled(YaComCheckbox)<{ disabled?: boolean }>`
  @media (hover: hover) and (pointer: fine) {
    ${({ disabled }) => !disabled && 'cursor: pointer'};
  }
  img {
    margin: 0;
  }
`

const Checkbox = (props: CheckboxProps) => {
  return (
    <CheckboxStyle
      role="checkbox"
      aria-checked={!!props.checked}
      aria-disabled={!!props.disabled}
      {...props}
    />
  )
}

export default Checkbox
